import {
  DISPLAY_CUSTOM_TEAM_MODAL,
  DISPLAY_LIST_MODAL,
  DISPLAY_LOAD_SAVE_MODAL,
  // DISPLAY_SUCCESS_MODAL,
  DISPLAY_VIDEO_MODAL,
  DISPLAY_MODIFY_TITLE_MODAL,
  DISPLAY_NEW_WHEEL_DROP,
  DISPLAY_PRESET_GROUP_MODAL,
  SET_RESULT_MODAL_APPEAR,
  DISPLAY_CREATE_CERT_MODAL,
} from './constants'

export const displayListModal = display => ({
  type: DISPLAY_LIST_MODAL,
  payload: {
    display,
  },
})

export const displayLoadSaveModal = display => ({
  type: DISPLAY_LOAD_SAVE_MODAL,
  payload: {
    display,
  },
})

// export const displaySuccessModal = display => ({
//   type: DISPLAY_SUCCESS_MODAL,
//   payload: {
//     display,
//   },
// })

export const displayCustomTeamModal = display => ({
  type: DISPLAY_CUSTOM_TEAM_MODAL,
  payload: {
    display,
  },
})

export const displayVideoModal = video => ({
  type: DISPLAY_VIDEO_MODAL,
  payload: {
    video,
  },
})

export const displayModifyTitleModal = display => ({
  type: DISPLAY_MODIFY_TITLE_MODAL,
  payload: {
    display,
  },
})

export const displayNewWheelDrop = display => ({
  type: DISPLAY_NEW_WHEEL_DROP,
  payload: {
    display,
  },
})

export const displayPresetGroupModal = display => ({
  type: DISPLAY_PRESET_GROUP_MODAL,
  payload: {
    display,
  },
})

export const setResultModalAppear = appear => ({
  type: SET_RESULT_MODAL_APPEAR,
  payload: {
    appear,
  },
})

export const displayCreateCertModal = display => ({
  type: DISPLAY_CREATE_CERT_MODAL,
  payload: {
    display,
  },
})
